import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Table } from "semantic-ui-react"

const VersionsTable = ({ onSelect, selectedVersion, versions }) => (
	<Table selectable>
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell>Id</Table.HeaderCell>
				<Table.HeaderCell>Data modyfikacji</Table.HeaderCell>
				<Table.HeaderCell>Status</Table.HeaderCell>
				<Table.HeaderCell>Osoba odpowiedzialna</Table.HeaderCell>
				<Table.HeaderCell>Treść notyfikacji</Table.HeaderCell>
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{versions.map(version => (
				<Table.Row
					active={
						version.caseStatusVersionId === get(selectedVersion, "caseStatusVersionId")
					}
					key={version.caseStatusVersionId}
					onClick={event => onSelect(event, version)}>
					<Table.Cell>{get(version, "caseStatusVersionId")}</Table.Cell>
					<Table.Cell>{get(version, "createDate")}</Table.Cell>
					<Table.Cell>{get(version, "status")}</Table.Cell>
					<Table.Cell>{get(version, "official")}</Table.Cell>
					<Table.Cell>{get(version, "notificationsTxt")}</Table.Cell>
				</Table.Row>
			))}
		</Table.Body>
	</Table>
)

VersionsTable.propTypes = {
	onSelect: PropTypes.func.isRequired,
	selectedVersion: PropTypes.object,
	versions: PropTypes.array
}

VersionsTable.defaultProps = {
	versions: []
}

export default VersionsTable



// WEBPACK FOOTER //
// ./src/containers/case-status-history/components/VersionsTable.js